import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Image, Download, MoreVertical, AlertCircle, CheckCircle } from 'lucide-react';
import { MOCK_DOCUMENTS } from '../../utils/mockData';
export function DocumentGrid() {
  const getIcon = (type: string) => {
    return type === 'pdf' ? <FileText className="h-8 w-8 text-red-500" data-id="element-906" /> : <Image className="h-8 w-8 text-blue-500" data-id="element-907" />;
  };
  const getStatusBadge = (status: string) => {
    return status === 'verified' ? <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-908">
        <CheckCircle className="w-3 h-3 mr-1" data-id="element-909" /> Verified
      </span> : <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800" data-id="element-910">
        <AlertCircle className="w-3 h-3 mr-1" data-id="element-911" /> Expired
      </span>;
  };
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-912">
      {MOCK_DOCUMENTS.map((doc, index) => <motion.div key={doc.id} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.1
    }} whileHover={{
      y: -4,
      boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
    }} className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm transition-all cursor-pointer group" data-id="element-913">
          <div className="flex justify-between items-start mb-4" data-id="element-914">
            <div className="p-3 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-colors" data-id="element-915">
              {getIcon(doc.type)}
            </div>
            <button className="text-gray-400 hover:text-gray-600" data-id="element-916">
              <MoreVertical className="h-5 w-5" data-id="element-917" />
            </button>
          </div>

          <h4 className="text-sm font-medium text-gray-900 truncate mb-1" data-id="element-918">
            {doc.name}
          </h4>
          <p className="text-xs text-gray-500 mb-4" data-id="element-919">
            {doc.size} • {doc.date}
          </p>

          <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-920">
            {getStatusBadge(doc.status)}
            <button className="text-gray-400 hover:text-blue-600" data-id="element-921">
              <Download className="h-4 w-4" data-id="element-922" />
            </button>
          </div>
        </motion.div>)}
    </div>;
}